function t(t){return t.split("-")[0]}export{t as default};
//# sourceMappingURL=getBasePlacement.js.map
